module.exports = __webpack_public_path__ + "static/media/max-k-30.a9c60e37.png";